import { HttpAuth, HttpUpload } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeScreen } from './navigation.action'
import { changeNotify } from './notify.action'
import { index as app} from './app.action'
import { changeAlert } from './alert.action'

export const gateways = [
    { gateway: 'efipay',      available: true , info: 'Fisica ou PJ - taxa de 1.19%',  label: 'EFI BANK',      className: 'badge-efipay' },
    { gateway: 'paysure',     available: true , info: 'Fisica ou PJ - taxa de 2%',     label: 'PAYSURE',       className: 'badge-paysure' },
    { gateway: 'avexpay',     available: true , info: 'Fisica ou PJ - taxa de 2.49%',  label: 'AVEXPAY',       className: 'badge-avexpay' },
    { gateway: 'infrapay',    available: true , info: 'PJ - taxa de 1.99%',            label: 'INFRAPAY',      className: 'badge-infrapay' },
    { gateway: 'pay2m',       available: true , info: 'PJ - taxa de 2.49%',            label: 'PAY2M',         className: 'badge-pay2m' },
    { gateway: 'codepay',     available: true , info: 'PJ - taxa de 1.89%',            label: 'CODE PAY',      className: 'badge-codepay' },
    { gateway: 'paggue',      available: false ,info: 'Fisica ou PJ - taxa de 1.49%',  label: 'PAGGUE',        className: 'badge-paggue' },
    { gateway: 'fluxsis',     available: false ,info: 'PJ - taxa de 1.99%',            label: 'FLUXSIS',       className: 'badge-fluxsis' },
    { gateway: 'ezzy',        available: false ,info: 'Fisica ou PJ - taxa de 2.49%',  label: 'EZZY BANK',     className: 'badge-ezzy' },
    { gateway: 'suitpay',     available: false ,info: 'PJ - taxa de 2.49%',            label: 'SUIT PAY',      className: 'badge-suitpay' },
    { gateway: 'pagstar',     available: true , info: 'PJ - taxa de 2.49%',            label: 'PAGSTAR',       className: 'badge-pagstar' },
    { gateway: 'infopago',    available: true , info: 'PJ - taxa de 2.49%',            label: 'INFOPAGO',      className: 'badge-infopago' },
    { gateway: 'mercadopago', available: true , info: 'Fisica ou PJ - taxa de 0.99%',  label: 'MERCADO PAGO',  className: 'badge-mercadopago' },
]

export const banks = 
{
    pay2m: {
        register: 'https://wa.me/5511945966869',
        playstore: 'https://play.google.com/store/apps/details?id=br.com.pay2m.client',
        apple_store: 'https://apps.apple.com/br/app/pay2m/id6743003137'
    },
    avexpay: {
        register: 'https://app.avexpay.com.br/register'
    },
    paysure: {
        register: 'https://paysure.com.br/register'
    },
    fluxsis: {
        register: 'https://wa.me/5547988604220',
        playstore: 'https://play.google.com/store/apps/details?id=br.com.infopago',
        apple_store: 'https://apps.apple.com/br/app/fluxsis-infopago/id1660584431'
    },
    infrapay: {
        register: 'https://infrapay.tech',
        playstore: 'https://play.google.com/store/apps/details?id=finance.onz.infrapay',
        apple_store: 'https://apps.apple.com/br/app/infrapay/id6775519643'
    },
    codepay: {
        register: 'https://www.codepay.one/auth/register-account',
        playstore: 'https://play.google.com/store/apps/details?id=br.com.app.gpu3203951.gpu6e2092adf15ed6c2459410e671e23b5d',
        apple_store: 'https://apps.apple.com/br/app/codepay-one/id6742108364'
    },
    efipay: {
        register: 'https://sejaefi.com.br',
        playstore: 'https://play.google.com/store/apps/details?id=br.com.gerencianet.app',
        apple_store: 'https://apps.apple.com/br/app/ef%C3%AD-bank-conta-digital/id1443363326'
    },
    ezzy: {
        register: 'https://app.ezzybanking.com.br/login',
        playstore: null,
        apple_store: null,
        whatsapp: 'https://wa.me/558000003096'
    },
    suitpay: {
        register: 'https://wa.me/5511916502160',
        playstore: 'https://play.google.com/store/apps/details?id=com.suitpay',
        apple_store: 'https://apps.apple.com/br/app/suitpay/id1632130123'
    },
    mercadopago: {
        register: 'https://www.mercadopago.com.br',
        playstore: 'https://play.google.com/store/apps/details?id=com.mercadopago.wallet',
        apple_store: 'https://apps.apple.com/br/app/mercado-pago-banco-digital/id925436649'
    },
    paggue: {
        register: 'https://paggue.io',
        playstore: 'https://play.google.com/store/apps/details?id=com.paggueclientapp',
        apple_store: 'https://apps.apple.com/us/app/paggue/id1542988650'
    },
    pagstar: {
        register: 'https://pagstar.com',
        playstore: 'https://play.google.com/store/apps/details?id=finance.onz.pagstar.bank',
        apple_store: 'https://apps.apple.com/br/app/pagstar-pagamentos/id6621180343'
    }
}

export const actionTypes = {
    INDEX: 'ACCOUNT_INDEX',
    CHART: 'ACCOUNT_CHART',
    STORE: 'ACCOUNT_STORE',
    DESTROY: 'ACCOUNT_DESTROY',
    CHANGE: 'ACCOUNT_CHANGE',
    SUCCESS: 'ACCOUNT_SUCCESS',
    ERROR: 'ACCOUNT_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = () => dispatch => {
    return HttpAuth.get('/account')
            .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
}

// STORE

const toFormData = (data) => {
    const fd = new FormData();

    Object.entries(data || {}).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        // arquivo
        if (value instanceof File || value instanceof Blob) {
        fd.append(key, value);
        return;
        }

        // array
        if (Array.isArray(value)) {
        value.forEach((v, i) => {
            if (v === undefined || v === null) return;
            fd.append(`${key}[${i}]`, v instanceof Object ? JSON.stringify(v) : v);
        });
        return;
        }

        // objeto
        if (typeof value === 'object') {
        fd.append(key, JSON.stringify(value));
        return;
        }

        fd.append(key, String(value));
    });

    return fd;
}

export const store = (data) => dispatch => {
    dispatch(changeLoading({ open: true }))
    
    const hasFile = data?.efipay_certificate_p12 instanceof File;
    const http = hasFile ? HttpUpload : HttpAuth;
    const payload = hasFile ? toFormData(data) : data;

    return http.post('/account', payload)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(success(true))
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(changeScreen({ open: false }))
                    dispatch(app())
                }
            }
        })
        .catch(erro => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof erro.response !== 'undefined') {
                if(erro.response.status === 400) {
                    if(typeof erro.response.data === 'object'){
                        if(erro.response.data.errors) {
                            dispatch(error(erro.response.data.errors))
                        }
                        if(erro.response.data.msg) {
                            dispatch(changeAlert({
                                open: true,
                                msg: erro.response.data.msg,
                                class: erro.response.data.class
                            }))
                        }
                        
                        if(typeof erro.response.data.error !== undefined) {
                            if(typeof erro.response.data.error === 'string'){
                                if(erro.response.data.error) {
                                    dispatch( changeNotify({
                                        open: true,
                                        class: 'error',
                                        msg: erro.response.data.error
                                    }))
                                }
                            }
                        }
                    }
                }
            }
        })
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/account/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }

                        if(typeof error.response.data.class !== undefined) {
                            dispatch(changeNotify({
                                open: true,
                                msg: error.response.data.msg,
                                class: error.response.data.class
                            }))
                            dispatch(success(true))
                        }
                    }
                }
            }
        })
}

// UPDATE

export const update = (id, data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.put('/account/'+id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            dispatch(success(true))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(changeScreen({ open: false }))
                    dispatch(app())
                }
            }
        })
        .catch(erro => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof erro.response !== 'undefined') {
                if(erro.response.status === 400) {
                    if(typeof erro.response.data === 'object'){
                        if(erro.response.data.errors) {
                            dispatch(error(erro.response.data.errors))
                        }
                        if(erro.response.data.msg) {
                            dispatch(changeAlert({
                                open: true,
                                msg: erro.response.data.msg,
                                class: erro.response.data.class
                            }))
                        }
                        
                        if(typeof erro.response.data.error !== undefined) {
                            if(typeof erro.response.data.error === 'string'){
                                if(erro.response.data.error) {
                                    dispatch( changeNotify({
                                        open: true,
                                        class: 'error',
                                        msg: erro.response.data.error
                                    }))
                                }
                            }
                        }
                    }
                }
            }
        })
}

// NOTIFICATION

export const notificationUpdate = (id, data) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.post('/account/notification/'+id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            dispatch(success(true))
            
            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))

                    return '200'
                }
            }
        })
}

// DESTROY

export const destroyResponse = (payload) => ({
    type: actionTypes.DESTROY,
    payload
})

export const destroy = (id) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.delete('/account/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined') {
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
                dispatch(destroyResponse(id))
            }
        })
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }

                        if(typeof error.response.data.class !== undefined) {
                            dispatch(changeNotify({
                                open: true,
                                msg: error.response.data.msg,
                                class: error.response.data.class
                            }))
                            dispatch(success(true))
                        }
                    }
                }
            }
        })
}

// CHART 
export const chartResponse = (payload) => ({
    type: actionTypes.CHART,
    payload
})

export const chartGeneralPeriod = (query) => dispatch => {
    return HttpAuth.post('/account/chart/general/period?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({account: res.data?.account, period: res.data})))
}

export const chartGeneralHourly = (query) => dispatch => {
    return HttpAuth.post('/account/chart/general/hourly?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({hour: res.data})))
}